export const CONFIRMED_GET_DISEASE_HISTORY = "CONFIRMED_GET_DISEASE_HISTORY";
